import { render } from "./Pick.vue?vue&type=template&id=097761c8&scoped=true"
import script from "./Pick.vue?vue&type=script&lang=js"
export * from "./Pick.vue?vue&type=script&lang=js"

import "./Pick.vue?vue&type=style&index=0&id=097761c8&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097761c8"]])

export default __exports__